<template>
  <div id="app" style="padding: 0.5rem 16px; text-align: left" class="vue-dpn">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <form action="/">
        <van-search
          v-model="value"
          placeholder="请输入手机号或姓名"
          show-action
          shape="round"
          @search="onSearch"
        >
          <div slot="action" @click="onSearch"></div>
        </van-search>
      </form>

      <div style="">
        <div class="pending-list" style="padding-bottom: 2rem">
          <div v-if="currentListLoading">
            <van-skeleton title :row="3" />
          </div>

          <div v-if="!currentListLoading">
            <div
              class="pending-list-item"
              v-for="(item, index) in currentList"
              v-if="currentList.length"
              @click="editPerson(item)"
            >
              <div>
                <div class="cus-row cus-row-v-m">
                  <div class="cus-row-col-6">
                    <span class="ffr f-c-b5b5b5 s-24-33">
                      手机： {{ item.mobile }}</span
                    >
                  </div>
                  <div class="cus-row-col-6 t-al-r">
                    <span class="status-btn" @click.stop="switchStaffStatus(item)">
                      <!-- {{ item.remark ? "审核失败" : "审核中" }} -->
                      {{ item.is_active == 1 ? "有效" : "无效" }}

                      <span
                        style="
                          position: absolute;
                          top: 50%;
                          -webkit-transform: translateY(-50%);
                          transform: translateY(-50%);
                          right: 0.1rem;
                        "
                        ><van-icon name="play"
                      /></span>
                    </span>
                  </div>
                </div>

                <div style="margin-top: 0.2rem" class="in-bl-line">
                  <span
                    class="ffr f-c-757575 s-28-40"
                    style="font-weight: bold"
                    >{{ item.name }}</span
                  >
                </div>

                <div class="barrie-line-sa" style="margin-top: 0.4rem"></div>
              </div>

              <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
                <div class="cus-row-col-8">
                  <span class="ffr f-c-b5b5b5 s-24-33" @click="goDetail(item)"
                    >可用合同数：</span
                  >

                  <span
                    class="ffr f-c-b5b5b5 s-24-33"
                    @click="goDetail(item)"
                    style="font-weight: bold; color: #222222; font-size: 15px"
                    >{{
                      item.contract_active !== null
                        ? parseInt(item.contract_active)
                        : 0
                    }}</span
                  >

                  <span
                    class="copy-text ffr f-c-b5b5b5 s-24-33"
                    style="margin-left: 24px"
                    @click.stop="addContractNum(item)"
                    >添加份数</span
                  >
                </div>
                <div class="cus-row-col-4 t-al-r">
                  <span class="ffr f-c-b5b5b5 s-24-33">{{
                    item.valid_date
                  }}</span>
                </div>
              </div>

              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                v-if="canEdit(item)"
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="cancelLoan(item)"
                    :style="canCancel(item)"
                  >
                    <!--                                <div class="in-bl-v-m">-->
                    <!--                                    <van-icon name="delete"/>-->
                    <!--                                </div>-->
                    <span class="opr-span">取消</span>
                  </div>
                  <div class="cus-row-col-6 t-al-c" @click="editLoan(item)">
                    <!--                                <div class="in-bl-v-m" :style="canEdit(item)">-->
                    <!--                                    <van-icon name="edit" />-->
                    <!--                                </div>-->
                    <span class="opr-span">修改</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>
            </div>

            <div
              v-if="!currentList.length"
              class="t-al-c"
              style="margin-top: 0.96rem"
            >
              <img
                src="~@/assets/images/no_order.png"
                style="width: 2rem; display: inline-block"
              />
            </div>

            <div
              v-if="!currentList.length"
              class="t-al-c s-26-37 ffr f-c-b5b5b5"
              style="margin-top: 0.56rem"
            >
              暂无数据
            </div>
          </div>

          <!--                <div class="t-al-c in-bl-line" style="margin-top: .48rem;">-->
          <!--                    <div style="padding: 0.14rem 0.28rem;background-color: rgba(255, 255, 255, 0.75);border-radius: 0.3rem;border: solid 0.02rem #e4e4e4;color:#1889f8;display: inline-block;" @click="showMeiqia">-->
          <!--                        <van-icon name="service-o" size=".33rem" :style="{'vertical-align': 'middle'}"/>-->
          <!--                        <span class="f-c-1889f8 s-24-33 ffm in-bl" style="vertical-align: middle;margin-left: 0.1rem;">在线客服</span>-->
          <!--                    </div>-->
          <!--                </div>-->
        </div>
      </div>
    </van-pull-refresh>


    <div style="position: fixed; bottom: 128px; right: 24px;" @click="addCourse" v-if="(user_id == 2 || user_id == 8)"><div style="background-color: rgb(239, 239, 239); width: 40px; height: 40px; border-radius: 100%; position: relative;"><img src="@/assets/images/add_user.png" class="ab-t-t-x-y" style="width: 26px; height: 26px;"></div></div>


    <tar-bar @showqr="showqr"></tar-bar>


    <!-- start of 游客编辑 -->
    <van-popup
      v-model="person_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <!--字符、注册年限、组合类型、注册类型、年限进行筛选-->

      <div
        style="
          box-shadow: 0px 2px 5px #eeeeee;
          background: #ffffff;
          margin-top: 2px;
        "
      >
        <van-cell title="" is-link value="关闭" @click="person_show = false" />
      </div>

      <!--用tab操作-->
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <van-field
              name="checkboxGroup"
              label="姓名"
              v-model="current_person.name"
            >
            </van-field>
            <!-- 
            <van-field name="radio" label="证件类型">
                
            </van-field> -->

            <van-field
              name="checkboxGroup"
              label="手机号码"
              v-model="current_person.mobile"
            >
            </van-field>

           

            <van-field
              name="checkboxGroup"
              label="证件号"
              v-model="current_person.id_card"
            >
            </van-field>

            <!-- 状态 -->
            <!-- <van-field
              name="checkboxGroup"
              label="状态"
              v-model="current_person.is_active"
            >
            </van-field> -->

            <van-field name="radio" label="状态">
              <template #input>
                <van-radio-group v-model="current_person.is_active" direction="horizontal">
                  <van-radio :name="1">有效</van-radio>
                  <van-radio :name="0">无效</van-radio>
                </van-radio-group>
              </template>
            </van-field>

           

            <van-field
              name="checkboxGroup"
              label="密码"
              v-model="current_person.password"
              placeholder="默认手机号，不填则不改"
            >
            </van-field> 
          </van-form>

         
        </div>
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="deletePerson"
              >取消</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="choseTemplate"
              >继续
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- end of 游客编辑 -->


    <van-popup
      v-model="show"
      position="bottom"
      closeable
      close-icon-position="top-right"
      :style="{ height: 'auto' }"
      :close-on-click-overlay="false"
      ref="pop"
    >
      <div
        style="
          background-color: #ffffff;
          padding: 0.72rem 0.48rem 0.48rem 0.48rem;
        "
      >
        <div class="wx-text">微信扫一扫，申请分期</div>

        <div
          style="
            margin-top: 0.16rem;
            font-family: PingFangSC-Regular;
            font-size: 0.28rem;
            font-weight: normal;
            color: #222222;
          "
        >
          请向客户出示此二维码，长按图片/截屏保存到相册
        </div>

        <div
          style="
            background-color: #1889f9;
            padding: 0.14rem 0.16rem 0.18rem 0.16rem;
            border-radius: 0.16rem;
            margin-top: 0.48rem;
          "
        >
          <div
            style="
              background-color: #ffffff;
              border-radius: 0.08rem;
              padding-bottom: 90%;
              position: relative;
            "
          >
            <div class="ab-t-t-x-y" style="width: 70%; font-size: 0">
              <img :src="qrcodePath" style="width: 100%" />
            </div>
          </div>

          <div style="margin-top: 0.28rem" class="in-bl-line">
            <div
              style="
                width: 0.58rem;
                height: 0.58rem;
                background-color: #ffffff;
                border-radius: 0.72rem;
                border: solid 0.04rem #fffefe;
                display: inline-block;
                vertical-align: middle;
              "
            >
              <van-image round width="0.58rem" height="0.58rem" />
            </div>

            <div
              class="in-bl"
              style="
                margin-left: 0.28rem;
                font-family: PingFangSC-Medium;
                font-size: 0.32rem;
                color: #ffffff;
                vertical-align: middle;
              "
            >
              {{ edu_name }}
              <span style="font-family: PingFangSC-Light">客户分期二维码</span>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- start of 分配代理 -->
    <div
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9;
      "
      class="t-al-c"
      v-if="owner_delegate_show"
    >
      <div
        style="
          position: absolute;
          background: rgba(26, 26, 26, 0.85);
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
        "
      ></div>
      <div
        class="ab-t-t-x-y"
        style="
          width: 300px;
          min-height: 100px;
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
        "
      >
        <div
          role="dialog"
          aria-labelledby="标题"
          class=""
          style="z-index: 10"
        >
          <div class="van-dialog__header" style="font-size: 14px">
            {{ current_add_item.name }}--新增数量（可填负数）
          </div>
          <div class="van-dialog__content">
            <div style="margin: 20px 0; padding: 0 20px">
              <input
                v-model="contract_num"
                style="
                  border-radius: 4px;
                  background-color: white; /* 背景颜色 */
                  font-size: 16px;
                  color: #222222;
                  width: 100%;
                  height: 44px;
                  line-height: 44px;
                  border: 1px solid;
                  padding: 0 6px;
                  box-sizing: border-box;
                  font-size: 16px;
                "
                type="number"
              />
              <!-- <select
                v-model="contract_type"
                style="
                  width: 100%;
                  padding: 8px 12px;

                  border-radius: 4px;
                  background-color: white; /* 背景颜色 */
                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 轻微阴影效果 */
                  font-size: 16px;
                  color: #666;
                "
              >
                <option value="A00001">
                    境内游合同
                </option>

                <option value="C00001">
                    出境游合同
                </option>
              </select> -->
            </div>
          </div>
          <div
            class="van-hairline--top van-dialog__footer van-dialog__footer--buttons"
          >
            <button
              class="van-button van-button--default van-button--large van-dialog__cancel"
              @click="cancelSetDelegate"
            >
              <span class="van-button__text">取消</span></button
            ><button
              class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left"
              @click="confirmSetDelegate"
            >
              <span class="van-button__text">确认</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- start of 分配代理 -->
  </div>
</template>


<script>
import common from "@/assets/js/common";
import TarBar from "../components/TarBar";
import { Dialog, Toast } from "vant";
import _ from "underscore";
import moment from "moment";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data: function () {
    return {
      user_id: common.getAuth(),
      periodArr: [3, 6, 9, 12, 24],
      period: "",
      price: "",
      class_name: "",
      pending_list: [],
      show: false,
      qrcodePath: common.dynamicHost() + "/entry_qrcode.png",
      userInfo: {},
      edu_name: {},
      edu_phone: {},
      pending_total_amount: 0,
      amount_all: 0,
      count_all: 0,
      count_current_month: 0,
      isLoading: false,
      value: "",
      contract_num: "",
      owner_delegate_show: false,
      current_add_item: {},

      option1: [
        { text: "全部状态", value: 0 },
        { text: "待审核", value: 1 },
        { text: "已生效", value: 2 },
      ],
      option2: [
        { text: "全部时间", value: 0 },
        { text: "今天", value: 1 },
        { text: "本月", value: 2 },
        { text: "今年", value: 3 },
      ],
      value1: 0,
      value2: 1,
      filterFixed: false,
      currentListLoading: true,
      user: {},
      person_show: false,
      current_person: {
        department_id: 21,
        role: 1,
        mobile: "",
        id_card: "",
        id: "",
        is_active: 1,
        password: ""
      }
    };
  },
  components: {
    TarBar,
  },
  methods: {

    editPerson(item){

      if(this.user_id != 2 && this.user_id != 8){
        return
      }
      this.current_person.department_id = item.department_id;
      this.current_person.role = item.role;
      this.current_person.mobile = item.mobile;
      this.current_person.id_card = item.id_card;
      this.current_person.id = item.id;
      this.current_person.is_active = item.is_active;
      this.current_person.name = item.name;
      // this.current_person.password = item.password;
      this.person_show = true;
    },

    deletePerson(){
      this.person_show = false;
    },

    choseTemplate(){
      // console.log("选择用户末班")
      // console.log(this.current_person)

      // return

      let _self = this;

      common
        .cusHttp(
          this,
          "/admin_user.php?action=add_or_modify_staff",
          this.current_person,
          "post"
        )
        .then((res) => {
          console.log("user_info返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            // this.user = res.result
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            // this.$router.push({ path: "new_invoice?id=" + res.data });
            console.log("修改数量成功")
            // item.is_active = res.data.is_active
            common.mAlert(_self, "操作成功");
            this.person_show = false;
            // this.initPage();
            this.onRefresh()
          }else{
            common.mAlert(_self, res.errmsg);
          }
        });


      
      
    },

    addCourse() {
      // this.course_data.push({
      //   // id: this.course_data.length + 1,
      //   name: "",
      //   area: "",
      //   address: "",
      //   industry_name: "",
      //   branch_scheme: "",
      //   size: "",
      //   editable: true,
      // });

      this.current_person = {
        department_id: 21,
        role: 1,
        mobile: "",
        id_card: "",
        id: "",
        is_active: 1,
        password: ""
      }

      // this.person_index = this.course_data.length - 1;
      // this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },

    switchStaffStatus(item){
      console.log("切换状态",item)


      //TODO 
      Dialog.confirm({
        title: "确认要" + (item.is_active?"失效":"激活") + "当前用户?",
      })
        .then(() => {
          // common.setSaAuth("");
          // common.setSaAuthWithRefresh("");
          // location.href = "sa_login";

          common
        .cusHttp(
          this,
          "/admin_user.php?action=set_staff_active",
          { id: item.id, is_active: item.is_active?0:1 },
          "post"
        )
        .then((res) => {
          console.log("user_info返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            // this.user = res.result
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            // this.$router.push({ path: "new_invoice?id=" + res.data });
            console.log("修改数量成功")
            item.is_active = res.data.is_active
            common.mAlert(_self, "操作成功");
          }else{
            common.mAlert(_self, res.errmsg);
          }
        });


        })
        .catch(() => {});
    },
    cancelSetDelegate() {
      this.owner_delegate_show = false;
    },

    confirmSetDelegate() {
      // this.owner_delegate_show = false
      if (!this.contract_num) {
        console.log("输出mAlert")
        common.mAlert(this, "请填写数量");
        return;
      }

      this.owner_delegate_show = false;

      //TODO
      common
        .cusHttp(
          this,
          "/admin_user.php?action=add_staff_contract_num",
          { id: this.current_add_item.id, num: this.contract_num },
          "post"
        )
        .then((res) => {
          console.log("user_info返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 0) {
            // this.user = res.result
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            // this.$router.push({ path: "new_invoice?id=" + res.data });
            console.log("修改数量成功")
            this.current_add_item.contract_active = res.data.contract_active
          }
        });
    },

    addContractNum(item) {
      console.log("添加合同份数");
      console.log(item);

      this.current_add_item = item;
      this.contract_num = "";
      this.owner_delegate_show = true;
    },

    onSearch() {},
    showMeiqia() {},
    onRefresh() {
      this.isLoading = false;
      location.reload();
    },
    doCopy: function (text) {
      let _self = this;
      this.$copyText(text).then(
        function (e) {
          common.mAlert(_self, "复制成功");
        },
        function (e) {
          common.mAlert(_self, "复制失败");
        }
      );
    },
    add() {
      location.href = "sa_fill";
    },
    setPeriod(period) {
      this.period = period;
      // console.log(period);
      //要用上选择器了
      var objs = document.querySelectorAll(".term-item-active");
      for (var i = 0, j = objs.length; i < j; i++) {
        objs[i].classList.remove("term-item-active");
      }
      var classList = document
        .querySelector('div[data-period="' + period + '"]')
        .classList.add("term-item-active");
      console.log(classList);
    },
    nextStep() {
      //验证
      if (!this.class_name) {
        // this.$layer.msg('请输入课程名称')
        common.mAlert(this, "请输入课程名称");
        return;
      }

      if (!this.price) {
        common.mAlert(this, "请输入课程金额");
        return;
      }

      if (!this.period) {
        common.mAlert(this, "请选择课程期数");
        return;
      }

      common.authRequest({
        url: common.dynamicHost() + "/user/save-fill",
        page: this,
        type: "get",
        data: {
          class_name: this.class_name,
          period: this.period,
          price: this.price,
        },
        indicator: true,
        success: function (res) {
          if (res.status) {
            location.href = "info";
          }
        },
        error: function () {},
      });
    },
    initPage() {
      // alert(33)

      console.log("请求网络");
      common
        .cusHttp(
          this,
          "/admin_user.php?action=staff_list",
          { pageNo: 1, pageSize: 1000 },
          "get"
        )
        .then((res) => {
          console.log("job_wait_deal_all返回", res);
          res = JSON.parse(res.data);
          if (res.errcode == 200) {
            // this.static = res.data
            // console.log(JSON.stringify(res.data.loan_list));
            // this.list = res.data.loan_list;
            this.pending_list = res.result.data;
            this.currentListLoading = false;
          }
        });
    },
    loginOut() {
      Dialog.confirm({
        title: "确认退出登录?",
      })
        .then(() => {
          common.setSaAuth("");
          common.setSaAuthWithRefresh("");
          location.href = "sa_login";
        })
        .catch(() => {});
    },
    showqr(value) {
      this.show = true;
    },
    goDetail(item) {
      this.$router.push({ path: "new_invoice?id=" + item.id });
    },
    goFill() {
      location.href = "sa_fill";
    },
    goFinish() {
      location.href = "sa_done_list";
    },
    cancelLoan(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) === -1) {
        return "";
      }
      this.goDetail(item);
    },
    editLoan(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) === -1) {
        return "";
      }

      this.goDetail(item);
    },
    canCancel(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) !== -1) {
        return true;
      }
      return false;
    },
    canEdit(item) {
      let stageArr = ["101", "201", "301"];
      if (stageArr.indexOf(item.stage) !== -1) {
        return true;
      }
      return false;
    },
    getLast1Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的10月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth =
          parseInt(month) < 10 ? "0" + parseInt(month) : parseInt(month);
        dateObj.last = year + "-" + resultMonth + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    getLastWeek() {
      return {
        now: moment().format("YYYY-MM-DD"),
        last: moment().subtract("days", 6).format("YYYY-MM-DD"),
      };
    },
    getLast3Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的10月份
        dateObj.last = parseInt(year) - 1 + "-10-" + day;
        return dateObj;
      }
      if (parseInt(month) == 2) {
        //如果是2月份，则取上一年的11月份
        dateObj.last = parseInt(year) - 1 + "-11-" + day;
        return dateObj;
      }
      if (parseInt(month) == 3) {
        //如果是3月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 3, 0).getDate(); //开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth =
          parseInt(month) - 2 < 10
            ? "0" + parseInt(month) - 2
            : parseInt(month) - 2;
        dateObj.last = year + "-" + resultMonth + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 3) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 3) + "-" + day;
        return dateObj;
      }
    },
  },
  created: function () {
    // common.setTitle('APA PPF')
  },
  computed: {
    btn_lock: function () {
      return true;
    },
    pending_list_count() {
      if (!this.pending_list) {
        return 0;
      }

      return this.pending_list.length;
    },
    currentList() {
      let keyword = this.value;
      let target_arr = [];
      for (let i = 0, j = this.pending_list.length; i < j; i++) {
        let record = JSON.stringify(this.pending_list[i]);
        console.log("关键字");
        console.log(record);
        if (record.indexOf(keyword) !== -1) {
          target_arr.push(this.pending_list[i]);
        }
      }

      return target_arr;

      //状态过滤, 待完成1 ['101', '201', '301', '401', '402', '403', '501', '601']，已通过2 ['602', '701']， 已结束3 ['801']
      // _.where(this.pending_list, )
      // let targetList = []
      // if ( this.value1 == 1 ) {
      //   for (let i = 0, j = this.pending_list.length; i < j; i++) {
      //     let stageArr = [0]
      //     if (stageArr.indexOf(this.pending_list[i].status) !== -1) {
      //       targetList.push(this.pending_list[i])
      //     }
      //   }
      // } else if (this.value1 == 1)
      // {
      //   for (let i = 0, j = this.pending_list.length; i < j; i++) {
      //     let stageArr = [0]
      //     if (stageArr.indexOf(this.pending_list[i].stage) !== -1) {
      //       targetList.push(this.pending_list[i])
      //     }
      //   }
      // } else
      // {
      //   targetList = this.pending_list
      // }
      //
      // console.log('过滤前的值')
      // console.log(targetList)
      //
      //
      // //按照日期筛选
      // let targetList2 = []
      // if( this.value2 == 1 )
      // {
      //   //今日
      //   // for (let i = 0, j = targetList.length; i < j; i++) {
      //   //   let today_date = moment().format('YYYY-MM-DD')
      //   //   if ( targetList[i].date == today_date ) {
      //   //     targetList2.push(targetList[i])
      //   //   }
      //   // }
      //
      //   targetList2 = targetList
      //
      // } else if( this.value2 == 2 )
      // {
      //   //近一月
      //   let monthRange = this.getLastWeek()
      //   console.log(monthRange)
      //
      //   for (let i = 0, j = targetList.length; i < j; i++) {
      //
      //     if( targetList[i].date <= monthRange.now && targetList[i].date >= monthRange.last )
      //     {
      //       targetList2.push(targetList[i])
      //     }
      //
      //     // let today_date = moment().format('YYYY-MM-DD')
      //     // if ( targetList[i].date == today_date ) {
      //     //     targetList2.push(targetList[i])
      //     // }
      //   }
      // } else if( this.value2== 3 )
      // {
      //   //近三月
      //
      //   let monthRange = this.getLast1Month()
      //   console.log(monthRange)
      //
      //   for (let i = 0, j = targetList.length; i < j; i++) {
      //
      //     if( targetList[i].date <= monthRange.now && targetList[i].date >= monthRange.last )
      //     {
      //       targetList2.push(targetList[i])
      //     }
      //
      //     // let today_date = moment().format('YYYY-MM-DD')
      //     // if ( targetList[i].date == today_date ) {
      //     //     targetList2.push(targetList[i])
      //     // }
      //   }
      // } else
      // {
      //   targetList2 = targetList
      // }
      //
      // console.log('过滤后的值')
      // console.log(targetList2)
      //
      // return targetList2

      //时间过滤，今日，近一月，进三月
    },
  },
  mounted() {
    if (!common.getAuth()) {
      this.$router.push({ path: "/auth" });
      return;
    }

    //移除vue-dpn
    common.removeDpnClass();
    this.initPage();
  },
};
</script>


<style scoped>
html,
body {
  background-color: #f5f5f5 !important;
}

.filter_content {
  margin-left: -0.4rem !important;
  margin-right: -0.4rem !important;
}

.filter-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  border-bottom: 1px solid #e4e4e4;
  box-shadow: 0 0 0.43rem 0 rgba(0, 0, 0, 0.06);
}

.opr-span {
  color: #212121;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.15rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
}

.copy-text {
  border: 1px solid #e4e4e4;
  border-radius: 0.33rem;
  padding: 0.02rem 0.1rem;
  margin-left: 0.04rem;
}

#app {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; /*禁用页面内容选中和复制操作*/
  -webkit-touch-callout: none; /*禁用长按页面时的弹出菜单(iOS下有效)*/
  -webkit-tap-highlight-color: rgba(
    0,
    0,
    0,
    0
  ); /*去掉点击链接和文本框对象时默认的灰色半透明覆盖层(iOS)或者虚框(Android)*/
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.in-bl {
  display: inline-block;
}

.term-item {
  background: #ffffff;
  border: 0.0325rem solid #cccccc;
  border-radius: 0.125rem;
  line-height: 1.25rem;
  width: 3rem !important;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.5rem;
  color: #333333;
  display: inline-block;
  margin-right: 0.25rem;
}

.term-item-active {
  border: 0.0325rem solid #fce701;
  background-color: #fce701;
}

.cheese_footer {
  font-family: PingFangSC-Regular;
  font-size: 0.3125rem;
  color: #b2b2b2;
  text-align: center;
  line-height: 0.4375rem;
}

.fix_footer {
  position: absolute;
  left: 50%;
  bottom: 2.5rem;
  text-align: center;
  z-index: 99;
}

.bottom_footer {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
}

.new-btn {
  line-height: 1rem;
  padding: 0 1rem;
  border-radius: 1rem;
  background-color: #1989fa;
  color: #ffffff;
  font-size: 0.4rem;
  transform: translateX(-50%);
}

.pending-list {
  margin-bottom: 2rem;
}

.pending-list-item {
  margin-top: 0.32rem;
  padding: 0.32rem 0.3rem;
  background-color: #ffffff;
  /*box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem*/
  /*rgba(0, 0, 0, 0.06);*/
  border-radius: 0.16rem;
  border: 1px solid #e4e4e4;
}

.status-btn {
  background-color: #f5f5f5;
  border-radius: 0.24rem;
  padding: 0 0.37rem 0 0.21rem;
  line-height: 0.45rem;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #111111;
  display: inline-block;
  position: relative;
}

.status-btn:after {
  position: absolute;
  right: 0.21rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.08rem;
  height: 0.12rem;
  background: url("");
  background-size: 0.08rem 0.12rem;
}

.wx-text {
  font-family: PingFangSC-Light;
  font-size: 0.56rem;
  color: #202021;
}

.opr-line .cus-row-col-6:nth-child(1) {
  border-right: 1px solid #e4e4e4;
  box-sizing: border-box;
}
</style>
